import { defineStore } from "pinia";
import type { CurrentDispatcher } from "@/api/dto/dispatcher.dto";
import type { DispatcherDto } from "@/api/dispatchers/dto/dispatcher.dto";

interface AppState {
  dispatcher?: AppStateDispatcher;
  dispatchers: DispatcherDto[];
  mobile: boolean;
  title: string;
  headerTitle: string;
  socketConnectionLost: boolean;
}

export interface AppStateDispatcher extends CurrentDispatcher {
  perms?: Record<string, string>;
  companyId?: number;
  companyName?: string;
  accountName?: string;
}

export const useAppStore = defineStore("appStore", {
  state: (): AppState => ({
    dispatchers: [],
    mobile: false,
    title: "",
    headerTitle: "",
    dispatcher: undefined,
    socketConnectionLost: false,
  }),
  getters: {
    getDispatcher: (state) => (id: number) => {
      return state.dispatchers.find((d) => d.id === id) || null;
    },
    companyId: (state): number | null => {
      return state.dispatcher?.companyId ?? state.dispatcher?.company?.id ?? null;
    },
  },
  actions: {
    setMobile(mobile: boolean) {
      this.mobile = mobile;
    },
    setDispatchers(dispatchers: DispatcherDto[]) {
      this.dispatchers = dispatchers;
    },
    setTitle(title: string) {
      this.title = title;
    },
    setHeaderTitle(headerTitle: string) {
      this.headerTitle = headerTitle;
    },
    setSocketConnectionLost(lost: boolean) {
      this.socketConnectionLost = lost;
    },
    setDispatcher(dispatcher: AppStateDispatcher) {
      if (dispatcher.company) {
        dispatcher.companyName = dispatcher.company.name;
      }

      this.dispatcher = dispatcher;
    },
  },
});
